// extracted by mini-css-extract-plugin
export default {"navbar":"ProtectedRoutes_navbar__2rAez","navbarMain":"ProtectedRoutes_navbarMain__Lfhjo","link":"ProtectedRoutes_link__NsNxE","AppShellMain":"ProtectedRoutes_AppShellMain__cMC5I"};